export const type_constant = {
  PROVIDER: "provider",
  APPLICANT: "applicant",
};


export const api_error_messages_to_exit = [
  "Token is not valid",
  "Refresh or Access Token is not valid",
  "Token is Expired",
  "Invalid token",
];



export const session_expired = "@session_expired";

export const save_tokens_constant = "@usertokens";


export const statusOptions = [
  { value: "Active", label: "Active", color: "green" },
  { value: "Inactive", label: "Inactive", color: "orange" },
  { value: "Blocked", label: "Blocked", color: "red" }
];

export const tagOptions = [ 
  { value: "VIP", label: "VIP", color: "gold" },
  { value: "Frequent Buyer", label: "Frequent Buyer", color: "blue" },
  { value: "Wholesale", label: "Wholesale", color: "purple" },
  // { value: "Returns Frequently", label: "Returns Frequently", color: "red" },
  // { value: "New Customer", label: "New Customer", color: "green" }
];